<template>
  <div id="distribuyionMap"></div>
</template>

<script>
import echarts from "echarts";
export default {
  name: "returnDistributionMap",
  props: {
    fieldServiceData: {
      type: Object,
      value: () => null,
    },
  },
  data() {
    return {
      chartDom: null,
      myCharts: null,
      options: {},
    };
  },
  mounted() {
    this.chartDom = document.getElementById("distribuyionMap");
    this.myCharts = echarts.init(this.chartDom);
    this.initOptions();
  },
  watch: {
    fieldServiceData() {
      this.initOptions();
    },
  },
  methods: {
    initOptions() {
      if (!this.fieldServiceData) return;
      this.options = {};
      let series = [];
      if (
        this.fieldServiceData.seriesList &&
        this.fieldServiceData.seriesList.length
      ) {
        for (let i = 0; i < this.fieldServiceData.seriesList.length; i++) {
          let info = this.fieldServiceData.seriesList[i];
          series.push({
            name: info.name,
            type: "bar",
            barWidth: 12,
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: info.data,
          });
        }
      }

      this.option = {
        dataZoom: [
          {
            show: false,
            realtime: true,
            start: 0,
            end: 160,
          },
          {
            type: "inside",
            realtime: false,
            start: 0,
            end: 160,
          },
        ],
        color: ["#44C885", "#AFE3C4"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          formatter: (params, ticket, callback) => {
            var htmlStr = "";
            for (let i = 0; i < params.length; i++) {
              let color = params[i].color;
              let seriesName = params[i].seriesName;
              let num = params[i].value;
              let marginBottom = 0;

              if (seriesName == "退货申请") {
                num = 0;
                params.forEach((item) => {
                  num += item.value;
                });
                marginBottom = 6;
              }

              htmlStr =
                `<div style="display:flex; margin-bottom: ${marginBottom}px;align-items: center;">
                    <span style="width:4px;height:4px;background-color: ${color};margin-right:4px"></span>
                    <span style="font-size: 12px; color: #fff">${seriesName}：${num}${
                  this.fieldServiceData.tag
                }</span>
                  </div>` + htmlStr;
            }

            return htmlStr;
          },
        },
        legend: {
          type: "scroll",
          top: "0px",
          right: "0px",
          itemStyle: {
            borderType: "dashed",
          },
          selectedMode: false,
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            color: "#9DA0A4",
          },
        },
        grid: {
          left: this.fieldServiceData.tag == "万元" ? "7%" : "5%",
          right: "0%",
          bottom: "0%",
          top: 35,
          containLabel: true,
        },
        xAxis: [
          {
            interval: 3,//横轴信息全部显示
            type: "category",
            data: this.fieldServiceData.xDataList
              ? this.fieldServiceData.xDataList
              : [],
            axisLabel: {
              interval:0,//横轴信息全部显示
              textStyle: {
                color: "#71747A",
              },
              formatter: function(params) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 1;
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                for (let row = 0; row < rowNumber; row++) {
                  newParamsName +=
                    params.substring(
                      row * provideNumber,
                      (row + 1) * provideNumber
                    ) + "\n";
                }
                return newParamsName;
              },
            },
            splitLine: { show: false },
            axisLine: { show: false },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            name:
              this.fieldServiceData && this.fieldServiceData.tag
                ? "单位（" + this.fieldServiceData.tag + "）"
                : "",
            type: "value",
            nameTextStyle: {
              color: "#C8C9CC",
            },
            axisLabel: {
              textStyle: {
                color: "#C8C9CC",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#E0E0E0",
              },
            },
            axisLine: { show: false },
            axisTick: {
              show: false,
            },
          },
        ],
        series: series,
      };
      this.option && this.myCharts.setOption(this.option);
    },
  },
};
</script>

<style scoped></style>
